import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import TreasuryAccount from "../../models/treasury";
import TreasuryAccountForm from "./TreasuryAccountForm";

interface TreasuryAccountUpdateModalProps {
  show: boolean;
  account?: TreasuryAccount;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const TreasuryAccountUpdateModal: React.FC<TreasuryAccountUpdateModalProps> = ({
  show,
  account,
  onCancel,
  onSuccess,
}) => {
  const modalTitle = account
    ? `Editar Cuenta: ${account.name}`
    : "Crear Cuenta Nueva";

  return (
    <CModal show={show} onClose={onCancel} size="lg">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <TreasuryAccountForm
            initialAccount={account}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default TreasuryAccountUpdateModal;
